<template>
  <div>
    <a-form layout="inline">
      <a-row :gutter="16">
        <a-col :span="6">
          <a-form-item label="设备编号">
            <a-input v-model.trim="value.deviceCode" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="设备名称">
            <a-input v-model.trim="value.deviceName" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="设备类型">
            <j-search-select-tag style="width: 200px;"
                                 placeholder="请选择设备类型"
                                 v-model="value.deviceCommonId"
                                 dict="efc_ocn_device_common_name,name,id" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="当前状态">
            <j-dict-select-tag style="width: 200px;"
                               placeholder="请选择当前状态"
                               v-model="value.status"
                               dictCode="device_status" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'queryInfo',
  props: {
    value: {}
  }
}
</script>